import toggleAttachment from './toggle-attachment'
import updateAccountGroupInput from './update-account-group-input'
import updateAttachmentGroupInput from './update-attachment-group-input'
import updateAccountMasterGroupInput from '@app/application/export/behaviors/export-form-tools/widgets/account/common/update-account-master-group-input'

export default function (element) {
  const $exportAccountInput = element
    .closest('tr')
    .find('.export-account-check input')
  const checked = $exportAccountInput.prop('checked')
  const groupUid = element
    .closest('table')
    .find('[data-behaviour="export-check-group-name"]')
    .attr('uid')
  const section = element.closest('[data-behaviour="export-element"]')

  section.find(`input#${$exportAccountInput.attr('id')}`).each(function () {
    if (
      groupUid !==
      $(this)
        .closest('table')
        .find('[data-behaviour="export-check-group-name"]')
        .attr('uid')
    ) {
      $(this).prop('checked', checked)
      toggleAttachment($(this))
      updateAccountGroupInput($(this).closest('table'))
      updateAttachmentGroupInput($(this).closest('table'))
      updateAccountMasterGroupInput($(this).closest('.check-master-group'))
    }
  })
}
